import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: null, // Stores user data (e.g., name, email, token)
  isAuthenticated: false, // Tracks login status
  userDocPath: null,
  isCorrupted: false, // Tracks if user has ghost Auth but no DB record
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // ✅ Handles user login
    authLogin: (state, action) => {
      const { userInfo, userDocPath } = action.payload || {};
      if (userInfo) {
        state.userInfo = userInfo;
        state.isAuthenticated = true;
        state.userDocPath = userDocPath;
      }
    },

    // ✅ Handles user logout
    authLogout: (state) => {
      state.userInfo = null;
      state.isAuthenticated = false;
      state.userDocPath = null;
      state.isCorrupted = false;
    },

    setCorrupted: (state, action) => {
      state.isCorrupted = action.payload;
    },

    // 🧩 Optional: Clear auth state (e.g., on app reset)
    resetAuth: () => initialState,
  },
});

export const { authLogin, authLogout, setCorrupted, resetAuth } = authSlice.actions;

export default authSlice.reducer;
